import { useState, useCallback } from 'react';
import { Employee } from '../types';

/**
 * Estado dos modais lazy (employee, settings, dashboard, HR, absences, version).
 * Centraliza abertura/fechamento para manter App.tsx só como composição.
 */
export function useModals() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [isHRModalOpen, setIsHRModalOpen] = useState(false);
  const [isAbsencesModalOpen, setIsAbsencesModalOpen] = useState(false);
  const [isVersionInfoOpen, setIsVersionInfoOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState<Employee | null>(null);
  const [employeeToDelete, setEmployeeToDelete] = useState<string | null>(null);

  const openNewEmployee = useCallback(() => {
    setEditingEmployee(null);
    setIsModalOpen(true);
  }, []);

  const openEditEmployee = useCallback((employee: Employee) => {
    setEditingEmployee(employee);
    setIsModalOpen(true);
  }, []);

  const closeEmployeeModal = useCallback(() => setIsModalOpen(false), []);

  return {
    isModalOpen,
    setIsModalOpen,
    isSettingsOpen,
    setIsSettingsOpen,
    isDashboardOpen,
    setIsDashboardOpen,
    isHRModalOpen,
    setIsHRModalOpen,
    isAbsencesModalOpen,
    setIsAbsencesModalOpen,
    isVersionInfoOpen,
    setIsVersionInfoOpen,
    isChangePasswordOpen,
    setIsChangePasswordOpen,
    editingEmployee,
    setEditingEmployee,
    employeeToDelete,
    setEmployeeToDelete,
    openNewEmployee,
    openEditEmployee,
    closeEmployeeModal,
  };
}
